import React, { useState, useEffect } from "react";
// import "./RemainingTime.css";
import { __ } from "services/Translator";
const RemainingTime = ({ endTime }) => {
  // alert(new Date(endTime * 1000));
  const calculateRemainingTime = () => {
    const now = new Date();
    // alert(now);
    const difference = Math.floor((endTime - now) / 1000); // Difference in seconds
    return difference > 0 ? difference : 0;
  };

  const formatTimeStamp = (timestamp) => {
    const days = Math.floor(timestamp / 86400);
    const hours = Math.floor((timestamp % 86400) / 3600);
    const minutes = Math.floor((timestamp % 3600) / 60);
    const seconds = Math.floor(timestamp % 60);

    return {
      days: days.toString().padStart(3, "0"),
      hours: hours.toString().padStart(2, "0"),
      minutes: minutes.toString().padStart(2, "0"),
      seconds: seconds.toString().padStart(2, "0"),
    };
  };

  const [timeLeft, setTimeLeft] = useState(
    formatTimeStamp(calculateRemainingTime())
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const remainingTime = calculateRemainingTime();
      if (remainingTime <= 0) {
        clearInterval(interval);
        setTimeLeft({ days: "000", hours: "00", minutes: "00", seconds: "00" });
      } else {
        setTimeLeft(formatTimeStamp(remainingTime));
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [endTime]);

  return (
    <>
      <div className="countdown d-none">
        <div className="time-box">
          <span className="time">{timeLeft.days}</span>
          <span className="label">DAYS</span>
        </div>
        <span className="separator">:</span>
        <div className="time-box">
          <span className="time">{timeLeft.hours}</span>
          <span className="label">HOUR</span>
        </div>
        <span className="separator">:</span>
        <div className="time-box">
          <span className="time">{timeLeft.minutes}</span>
          <span className="label">MIN</span>
        </div>
        <span className="separator">:</span>
        <div className="time-box">
          <span className="time">{timeLeft.seconds}</span>
          <span className="label">SEG</span>
        </div>
      </div>
      <div className="countdownArea">
        <ul>
          <li>
            <div className="countData">{timeLeft.days}</div>
            <label>{__("Days")}</label>
          </li>
          <li className="colon">
            <div className="countData">:</div>
          </li>
          <li>
            <div className="countData">{timeLeft.hours}</div>
            <label>{__("Hour")}</label>
          </li>
          <li className="colon">
            <div className="countData">:</div>
          </li>
          <li>
            <div className="countData">{timeLeft.minutes}</div>
            <label>{__("Min")}</label>
          </li>
          <li className="colon">
            <div className="countData">:</div>
          </li>
          <li>
            <div className="countData">{timeLeft.seconds}</div>
            <label>{__("Seg")}</label>
          </li>
        </ul>
      </div>
    </>
  );
};

export default RemainingTime;
